import React from 'react';
import { Link } from 'react-router-dom';
import { colors, fontFamily, fontSizes, fontWeights, radii, layout } from '../../theme/tokens';

const SIZES = {
  md: { minHeight: layout.buttonHeight, padding: '0 24px', fontSize: fontSizes.body },
  lg: { minHeight: layout.ctaHeight, padding: '0 28px', fontSize: fontSizes.bodyLg },
  sm: { minHeight: layout.touchTarget, padding: '0 18px', fontSize: fontSizes.small + 1 },
};

const VARIANTS = {
  primary: { background: colors.navy, color: colors.white, border: '1.5px solid ' + colors.navy },
  secondary: { background: colors.white, color: colors.navy, border: '1.5px solid ' + colors.softBlue },
  text: { background: 'transparent', color: colors.navy, border: '1.5px solid transparent' },
};

const Button = React.forwardRef(({
  variant = 'primary', size = 'md', fullWidth = false, disabled = false, loading = false,
  to, href, type = 'button', children, style, ...rest
}, ref) => {
  const isDisabled = disabled || loading;
  const base = {
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    width: fullWidth ? '100%' : undefined,
    borderRadius: radii.button,
    fontFamily,
    fontWeight: fontWeights.semibold,
    textDecoration: 'none',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.55 : 1,
    ...SIZES[size],
    ...VARIANTS[variant],
    ...(variant === 'text' ? { padding: '0 8px' } : null),
    ...style,
  };
  if (href && !isDisabled) {
    return <a ref={ref} href={href} style={base} {...rest}>{children}</a>;
  }
  if (to && !isDisabled) {
    return <Link ref={ref} to={to} style={base} {...rest}>{children}</Link>;
  }
  return (
    <button ref={ref} type={type} disabled={isDisabled} aria-busy={loading || undefined} style={base} {...rest}>
      {loading ? 'Please wait...' : children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
